import { useState } from 'react'
import { mutate } from 'swr'
import { Unshare_Teachers_Book } from '@graphql/mutations'
import { Books_Listing, Library_Books, User_SchoolClasses } from '@graphql/queries'
import { useApi } from '@hooks/useApi'

const useUnshareTeachersBook = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      {input: data},
      Unshare_Teachers_Book,
      successMessage,
      errorMessage,
      async () => {
        await mutate(User_SchoolClasses)
        await mutate(Books_Listing)
        await mutate(Library_Books)
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUnshareTeachersBook }
